import { ObjectSelect } from "./ObjectSelect";

export default ObjectSelect;
